<style lang="less" scoped>
@import '../../../style/common/variable';
.content {padding: 15px 0 30px;
  .national {width: 1200px;margin: 0px auto;}
  .layout {width: 1200px;margin: 0px auto;
    .introduceBox {width: 100%;height: auto;margin-top: 20px;
      .introduceBox_left_new {width: 1200px;min-height: 960px;vertical-align: top;
        .detailsP2 {width: 830px;height: 58px;border-bottom: 1px solid #ccc;margin: 0 auto;text-align-last: left;
          .detailsP2T {display: inline-block;height: 18px;line-height: 18px;font-size: 18px;color: #000000;border-left: 5px solid #289FDE;text-indent: 10px;margin-top: 20px;}}
        .detailsContent {text-align: center;width: 750px;margin: 30px auto;}
      }
    }
  }
}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .content .layout .introduceBox .introduceBox_left_new{width: 94vw; margin-left: 3vw;
    .detailsContent{width: 94vw;}
  }
}
</style>
<!-- 安进 东盟矿业—国家详情 -->
<template>
  <div class="content">
    <National></National>
    <div class="layout">
      <div class="introduceBox">
        <div class="introduceBox_left_new" id="description">
          <div class="detailsP2">
            <span class="detailsP2T" v-if="countries">{{ countries }}矿业概况</span>
          </div>
          <div class="detailsContent" v-html="CountriesDetails"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import National from '../assembly/National.vue'
export default {
  components: {
    National
  },
  data()
  {
    return {
      CountriesDetails: null,
      countries: null
    }
  },
  created()
  {
    this.getDetails()
  },
  methods: {
    getDetails()
    {
      //获取详情国家名称
      let paras1 = {
        cmd: 'query',
        _major: 11,
        _minor: 43,
        _exp: 'id=?',
        types: 'i',
        vals: this.$route.query.id
      }
      window.post.getPost(paras1).then((ret) =>
      {
        this.countries = ret[0].areaname
      })
      //获取详情文章内容
      let paras2 = {
        cmd: 'query',
        _major: 11,
        _minor: 44,
        _exp: 'id=?',
        types: 'i',
        vals: this.$route.query.id
      }
      window.post.getPost(paras2).then((ret) =>
      {
        this.CountriesDetails = window.public.decodeContent(ret[0].content)
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/project/DmkyDetails.vue